import { MailOutlined } from '@ant-design/icons'
import { ProviderHelperClient } from '~/plugins/data-connector/helpers/provider.helper.client'
import { ProviderAuthenticationClient } from '../../../authentication/client'
import { ProviderClient } from '../../abstract/provider.client'
import { ProviderOutlookMailCommon } from '../common'

const authentication = ProviderAuthenticationClient.Oauth2({
  ...ProviderOutlookMailCommon.authentication,
  clientId: ProviderHelperClient.getEnvVariable('outlook', 'CLIENT_ID'),
  authParams: {
    /**
     * ? Stop forcing the consent screen as this blocks organizational users
     * ? where their admins have already approved
     */
    prompt: undefined,
  },
})

export const ProviderOutlookMailClient: ProviderClient = {
  key: ProviderOutlookMailCommon.key,
  authentication,
  description: {
    label: 'Outlook Mail',
    icon: <MailOutlined />,
    triggers: [
      {
        key: 'NewEmail',
        label: 'New email',
        output: [
          {
            key: 'providerAccountId',
          },
          {
            key: 'message.id',
          },
          {
            key: 'to',
          },
          {
            key: 'snippet',
          },
          {
            key: 'content',
          },
        ],
      },
    ],
    actions: [],
  },
}
